import { appInfo } from "@/common/data/appinfo";

export default [
  {
    path: "/NVj77p3kZ",
    children: [
      {
        path: "/c1xLJjBict",
        name: "institutions",
        meta: {
          title: appInfo?.type === "codsmi" ? "Schools" : "Institutions",
          authRequired: true,
          acc: ["y75281"],
        },
        component: () => import("@/views/institution/list"),
      },
      {
        path: "/57Y3c5wn",
        name: "newinstitution",
        meta: {
          title: appInfo?.type === "codsmi" ? "New school" : "New institution",
          authRequired: true,
          acc: ["y11411"],
        },
        component: () => import("@/views/institution/new"),
      },
      {
        path: "/QgwXJ43/:id?",
        name: "institution",
        meta: {
          title:
            appInfo?.type === "codsmi" ? "View school" : "View institution",
          authRequired: true,
          acc: ["y59006"],
        },
        component: () => import("@/views/institution/view"),
      },
      {
        path: "/QgwXJ43WWEWEQD/:id?",
        name: "institution.edit",
        meta: {
          title:
            appInfo?.type === "codsmi" ? "Edit school" : "Edit institution",
          authRequired: true,
          acc: ["y43809"],
        },
        component: () => import("@/views/institution/edit"),
      },

      {
        path: "/081ed277a8092be8732c2c1c",
        name: "assignedInstitution",
        meta: {
          title: appInfo?.type === "codsmi" ? "Assigned Schools" : "Assigned Institutions",
          authRequired: true,
          acc: ["y91085"],
        },
        component: () => import("@/views/institution/assigned.vue"),
      },
      {
        path: "/08441921407e7ac643accde1",
        name: "assignInstitution",
        meta: {
          title: appInfo?.type === "codsmi" ? "Assign Schools" : "Assign Institutions",
          authRequired: true,
          acc: ["y48068"],
        },
        component: () => import("@/views/institution/assign.vue"),
      },
    ],
  },
];
